import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ActionsModal } from "../../../../../../components";
import { ActionsModalNames } from "../../../../../../components/ActionsModal";

import { AnalysisSelections } from "../../../../../../components/@types";
import Button from "../../../../../../components/button/Button";
import TooltipWrapper from "../../../../../../enhancers/TooltipWrapper";
import { useDataModal } from "../../../../../../hooks";
import {
  useGetSampleAnalysisStatus,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { useGetMergedRlcsReport } from "../../../rlcloudsandbox/hooks/useGetMergedRlcsReport";
import { useRlcsAnalysisStatus } from "../../../rlcloudsandbox/hooks/useRlcsAnalysisStatus";

type Props = {
  onReanalyze?: (payload: unknown) => void;
  initialAnalysisSelections?: AnalysisSelections;
  disabled?: boolean;
  tooltipMessage?: string;
  shouldRefetchRlcsAnalysisStatus?: boolean;
};

const ReanalyzeButton = ({
  onReanalyze,
  initialAnalysisSelections,
  disabled,
  tooltipMessage,
  shouldRefetchRlcsAnalysisStatus = true
}: Props) => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { data, onToggle } = useDataModal();
  const { refetchMergedReport } = useGetMergedRlcsReport(hash ?? "");
  const { refetch: refetchAnalysisStatus } = useGetSampleAnalysisStatus(hash);
  const { refetchAnalysisStatus: refetchRlcsAnalysisStatus } =
    useRlcsAnalysisStatus({
      hash: hash ?? "",
      refetchMergedReportFn: refetchMergedReport,
      pollDisabled: true
    });

  const fetchStatus = () => {
    refetchAnalysisStatus();
    if (shouldRefetchRlcsAnalysisStatus) {
      refetchRlcsAnalysisStatus();
    }
  };

  const handleReanalyzeClick = () => {
    const name = ActionsModalNames.Reanalyze;
    const values = {
      samples: [
        {
          hash_value: hash,
          source_id: sourceId,
          relationship_id: relationshipId
        }
      ],
      onReanalyzePopupWindowSubmit: (payload: unknown) => {
        fetchStatus();
        onReanalyze?.(payload);
      },
      initialAnalysisSelections
    };
    onToggle(values, name);
  };

  return (
    <>
      <TooltipWrapper
        condition={tooltipMessage}
        wrapper={(children: JSX.Element) => (
          <OverlayTrigger
            overlay={
              <Tooltip
                id="rlcs-reanalyze-tooltip"
                data-testid="rlcs-reanalyze-tooltip"
              >
                {tooltipMessage}
              </Tooltip>
            }
            placement="top"
          >
            <span>{children}</span>
          </OverlayTrigger>
        )}
      >
        <Button
          onClick={handleReanalyzeClick}
          variant="secondary"
          disabled={disabled}
          data-testid="report_summary_reanalyze_button"
        >
          REANALYZE
        </Button>
      </TooltipWrapper>
      {data.activeModal && (
        <ActionsModal
          modalName={data.activeModal}
          activeModalData={data.activeModalData}
          toggleModal={onToggle}
        />
      )}
    </>
  );
};

export default ReanalyzeButton;
